/* eslint-disable no-param-reassign */
export default {
    // SET_CONTRACTS(state, contracts) {
    //     state.contracts = contracts;
    // },
    // SET_ITEMS(state, items) {
    //     state.items = items;
    // }
};
